import { render, staticRenderFns } from "./MarginAllocation.vue?vue&type=template&id=de6f0d0c&scoped=true"
import script from "./MarginAllocation.vue?vue&type=script&lang=ts&setup=true"
export * from "./MarginAllocation.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./MarginAllocation.vue?vue&type=style&index=0&id=de6f0d0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de6f0d0c",
  null
  
)

export default component.exports